import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCCContext } from '../CC/CCContext';
import * as ccUtils from '../CC/utils';
import styles from './ObjAssoc.module.css';
import ObjAssocIcon from './ObjAssocIcon';

interface RecordProps {
    record: any; // Define a more specific type for your record
}

const ObjAssoc: React.FC<RecordProps> = ({ record }) => {
    const { t } = useTranslation();
    const [records, setRecords] = useState<any[]>([]);
    const ctx = useCCContext();
    const [isObjAssocVisible, setIsObjAssocVisible] = useState(false);


    const toggleObjAssoc = () => {
        setIsObjAssocVisible(!isObjAssocVisible);
    };

    useEffect(() => {
        const controller = new AbortController();
        const normalizeToArray = (value: any): any[] =>
            value ? (Array.isArray(value) ? value : [value]) : [];

        setRecords([]);
        const fetchTitles = async () => {
            const current = record?.data?.Record;
            const objectNumber = current?.ObjectNumber || current?.ObjectNumber2;
            if (!objectNumber) return;

            // Fetch incoming links separately, and outgoing links in small batches.
            const queries = [
                `/Record/Associations/ObjectNumber,/Record/IAssociations/ObjectNumber=[${objectNumber}]`
            ];
            const numbers = Array.from(new Set(
                [...normalizeToArray(current.Associations), ...normalizeToArray(current.IAssociations)]
                    .map((assoc: any) => assoc.ObjectNumber || assoc.ObjectNumber2)
                    .filter(Boolean)
            ));
            for (let index = 0; index < numbers.length; index += 10) {
                const parts = numbers.slice(index, index + 10).map(number =>
                    `/Record/ObjectNumber,/Record/ObjectNumber2=[${number}]`
                );
                queries.push(parts.length === 1 ? parts[0] : `or(${parts.join(';')})`);
            }

            const uniqueRecords = new Map<string, any>();
            for (const query of queries) {
                try {
                    const url = `${process.env.REACT_APP_BASE_URL}/?action=get&command=search&query=${encodeURIComponent(query)}&fields=*&range=1-200&responseFormat=json`;
                    const response = await fetch(url, { signal: controller.signal });
                    if (!response.ok) throw new Error(`Linked records request failed: ${response.status}`);
                    const data = await response.json();
                    if (controller.signal.aborted) return;

                    for (const item of normalizeToArray(data.records?.record)) {
                        const linked = item?.data?.Record;
                        if (linked?.ObjectNumber == null && linked?.ObjectNumber2 == null) continue;
                        const key = linked.ccObjectID != null
                            ? String(linked.ccObjectID)
                            : JSON.stringify([linked.source, linked.ObjectNumber, linked.ObjectNumber2]);
                        uniqueRecords.set(key, item);
                    }
                    setRecords(Array.from(uniqueRecords.values()));
                } catch (error) {
                    if (controller.signal.aborted) return;
                    console.error('Error fetching linked records:', error);
                }
            }
        };

        fetchTitles();
        return () => controller.abort();
    }, [record]);

    const handleLinkClick = (event: React.MouseEvent, index: number) => {
        event.preventDefault();
        const objectNumber = records[index].data?.Record?.ObjectNumber || records[index].data?.Record?.ObjectNumber2;
        console.log(objectNumber);
        console.log(records[index].data?.Record?.searchnumber);
        ccUtils.customSearch(ctx, '/Record/ObjectNumber,/Record/ObjectNumber2', '', '[' + objectNumber + ']', 'Numéro d\'inventaire' + ' : ' + objectNumber);
    };

    return (
        <div>
            {records.length > 0 &&
                <div className={styles.foldableSection}>
                    <div className={styles.foldableLabel} onClick={toggleObjAssoc}>
                        <span className={styles.taglabel}>{t('Notices reliées')} : </span> <button onClick={toggleObjAssoc} className={styles.toggleButtonAssoc}>{isObjAssocVisible ? '-' : '+'}</button>
                    </div>
                    {isObjAssocVisible && (
                        <div className={styles.objAssoc}>
                            <div className={styles.ObjAssoc}>
                                {records.map((record: any, index: number) => (
                                    <ObjAssocIcon
                                        key={index}
                                        record={record}
                                        index={index}
                                        handleLinkClick={handleLinkClick}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default ObjAssoc;
